// $( document ).ready(function() {
//   	$( "header-menu" ).hover(function() {
//         $("#Details-HeaderMenu-2").attr("open","");
//       	$(".header__menu-item").attr("aria-expanded",true);
//     }, function () {
//         $("#Details-HeaderMenu-2").removeAttr("open","");
//         $(".header__menu-item").attr("aria-expanded",false);
//     });
// });

$(".header-menu").on('mouseenter', 'header-menu details', function() {
    $(this).attr("open", "");
    $(this).find('summary').attr("aria-expanded", true);
});
$(".header-menu").on('mouseleave', 'header-menu details', function() {
    $(this).removeAttr("open", "");
    $(this).find('summary').attr("aria-expanded", false);    
});

$(window).on('load resize', function(){
    //Blog Detail
    var Headerheight= $('.article-template header').outerHeight();
    $('.article-template .sidebar').css('margin-top', -Headerheight ); 
});

 window.addEventListener("load", (event) => {
      jQuery('.appstle_subscription_option > input').on("click", function(event){
        var sellingplanid = jQuery(this).val();
        jQuery('#sellingplanid').val(sellingplanid);
        return true;
      });
      
      jQuery('.appstle_onetime > input').on("click", function(event){
        jQuery('#sellingplanid').val('');
        return true;
      });      
});
